import { mergeFieldMaps } from '@/common/utils/jsonUniData.ts'
import { stripServerEventOverlayFields } from '@/common/utils/stripServerEventOverlayFields'

export type BuildReloadFormRequestFieldsOptions = {
  /** dialogClosed: do not send the parent page snapshot (stale scalars) as currentData. */
  omitPageFieldSnapshot?: boolean
}

/** SwingForm.getData: layout.position=events collects nothing. */
export function isEventsLayoutAction(actionData: unknown): boolean {
  if (!actionData || typeof actionData !== 'object') return false
  const position = (actionData as { layout?: { position?: unknown } }).layout?.position
  const text =
    typeof position === 'string'
      ? position
      : position && typeof position === 'object'
        ? (position as { _text?: unknown })._text
        : ''
  return String(text ?? '').trim().toLowerCase() === 'events'
}

/** Fields for POST `/platform/reload/form`. Default = page snapshot + En overlay. */
export function buildReloadFormRequestFields(
  pageSnapshot: Record<string, unknown> | null | undefined,
  enOverlay: unknown,
  options?: BuildReloadFormRequestFieldsOptions,
): Record<string, unknown> {
  const overlay = stripServerEventOverlayFields(
    enOverlay && typeof enOverlay === 'object' && !Array.isArray(enOverlay)
      ? (enOverlay as Record<string, unknown>)
      : {},
  )
  if (options?.omitPageFieldSnapshot) {
    return overlay
  }
  const page =
    pageSnapshot && typeof pageSnapshot === 'object' && !Array.isArray(pageSnapshot)
      ? pageSnapshot
      : {}
  return mergeFieldMaps(page, overlay) as Record<string, unknown>
}
